import React, { useState } from 'react';
import { ShieldCheck } from 'lucide-react';
import { Button } from '../ui/button';
import { Input } from '../ui/input';
import { Label } from '../ui/label';

// Second sign-in step: 6-digit authenticator code, or a single-use backup code.
export const MfaStep = ({ onSubmit, onCancel, loading }) => {
  const [code, setCode] = useState('');
  const [backup, setBackup] = useState(false);
  const valid = backup ? code.trim().length >= 9 : /^\d{6}$/.test(code);
  return (
    <form onSubmit={(e) => { e.preventDefault(); if (valid) onSubmit(code.trim()); }} className="space-y-6" data-testid="mfa-form">
      <div className="flex items-start gap-3 rounded-lg bg-amber-50 border border-amber-200 p-4">
        <ShieldCheck className="h-5 w-5 text-amber-700 mt-0.5 shrink-0" />
        <p className="text-sm text-amber-900">
          {backup ? 'Enter one of your saved backup codes (like 1a2b-3c4d). Each code works once.' : 'Enter the 6-digit code from your authenticator app.'}
        </p>
      </div>
      <div>
        <Label className="label-overline">{backup ? 'Backup code' : 'Authenticator code'}</Label>
        <Input
          autoFocus value={code} onChange={(e) => setCode(backup ? e.target.value : e.target.value.replace(/\D/g, '').slice(0, 6))}
          inputMode={backup ? 'text' : 'numeric'} autoComplete="one-time-code" placeholder={backup ? 'xxxx-xxxx' : '123456'}
          className="mt-2 h-12 tracking-widest text-lg" data-testid="mfa-code-input"
        />
      </div>
      <Button type="submit" disabled={!valid || loading} className="w-full btn-primary h-12" data-testid="mfa-submit">
        {loading ? 'Verifying…' : 'Verify & Sign In'}
      </Button>
      <div className="flex justify-between text-sm">
        <button type="button" className="text-amber-700 hover:underline" onClick={() => { setBackup(!backup); setCode(''); }} data-testid="mfa-toggle-backup">
          {backup ? 'Use authenticator app instead' : 'Lost your phone? Use a backup code'}
        </button>
        <button type="button" className="text-neutral-500 hover:text-neutral-800" onClick={onCancel} data-testid="mfa-cancel">Start over</button>
      </div>
    </form>
  );
};
